import { useEffect, useState } from 'react'

import { Typography } from 'antd'
import dayjs from 'dayjs'

function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}

export function LiveTimer({
  targetDate,
  label,
  isEnd = false,
}: {
  targetDate: string
  label: string
  isEnd?: boolean
}) {
  const [timeLeft, setTimeLeft] = useState(0)

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = dayjs()
      const target = dayjs(targetDate)
      const diff = target.diff(now, 'second')
      setTimeLeft(Math.max(0, diff))
    }

    calculateTimeLeft()
    const interval = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(interval)
  }, [targetDate])

  const isWarning = isEnd && timeLeft >= 0 && timeLeft < 5 * 60
  const isExpired = timeLeft === 0

  return (
    <Typography.Text
      type={isExpired ? 'secondary' : isWarning ? 'danger' : undefined}
      strong={isWarning}
    >
      {label}: {formatTime(timeLeft)}
    </Typography.Text>
  )
}
